<app-fr-card class="top-list-container">
  <mat-card-header class="tl-header">
    <div mat-card-avatar>
      <mat-icon color="primary" class="tl-header-icon" [ngClass]="icon" *ngIf="icon"></mat-icon>
      <img data-src="/assets/images/dream11/top-donor.png" alt="Top Donor" *ngIf="img">
    </div>
    <mat-card-title class="tl-header-label">{{ cardType === 'supporters' ? (fundraiser?.raised?.backers + ' Supporters') : title}}</mat-card-title>
  </mat-card-header>
  <div class="tl-line"></div>
  <mat-card-content>
    <div class="tl-content">
      <div class="tl-unauth" *ngIf="donors?.error">
        <div *ngIf="donors?.error?.status==401">
          <span class="tl-unauth-txt">You need to sign in to view more Supporters.</span>
          <app-button class="tl-unauth-btn" btnClass="primary-btn" label="Sign In" (click)="navigateToSignIn()"></app-button>
        </div>
        <div *ngIf="donors?.error?.status==403">
          <span class="tl-unauth-txt">Only supporters of this fundraiser can view more supporters.</span>
          <app-donate-now *ngIf="!isFundraiserEnded" class="tl-unauth-btn" label="Contribute" [position]="13"></app-donate-now>
        </div>
      </div>
      <div class="supporter-Section-bank" data-bg="../assets/images/upi-card-bg.png" *ngIf="!isFundraiserEnded && currencyInfo?.currency=='INR' && cardType=='supporters' && view !== 'dream11'">
        <span class="heading">Contributed VIA BANK / PAYTM / UPI ?</span>
        <span class="click-here"><a (click)="ackPopup()">Click here</a> if you can't find your contribution listed below.</span>
      </div>
      <div *ngIf="cardType=='supporters' && !settings?.norecenttab" class="tl-sort" [ngClass]="{'d11': view === 'dream11'}">
        <a class="tl-sort-btn" [ngClass]="getSortOrder('donated_amount')" (click)="sortDonors('donated_amount')" mat-button>Most Generous</a>
        <hr class="tl-hline">
        <a class="tl-sort-btn" [ngClass]="getSortOrder('id')" (click)="sortDonors('id')" mat-button>Recent</a>
      </div>
      <div #listContainer class="tl-content-container" [ngClass]="{'matching-donor' : cardType === 'supporters' && fundraiser?.matching_donor}" [class]="cardType === 'supporters' ? 'animate-container' : ''">
        <app-placeholder-loader *ngIf="isLoading" type="donor" [count]="5"></app-placeholder-loader>
        <div *ngIf="!isLoading">
          <div *ngFor="let donor of donors?.data">
            <app-donor [donor]="donor" [type]="type" [showTime]="donorsOrderBy=='creation_date'"></app-donor>
            <div *ngFor="let comment of donor?.comments" class="list-comment"><i class="icon-leftquote quotes-icon"></i>{{comment.text}}<i class="icon-rightquote quotes-icon"></i></div>
            <app-matching-donation-card *ngIf="donor?.matching_donation" origin="list" [campaigner]="fundraiser?.matching_donor" [matchingDonation]="donor?.matching_donation"></app-matching-donation-card>
          </div>
        </div>
        <app-donate-now *ngIf="cardType=='topDonor' && !isFundraiserEnded"
                        class="flex-container-row" [icon]="true" [label]="donateBtnLabel"
                        [position]="5" [fundraiser]="fundraiser">
        </app-donate-now>
        <app-fb-share *ngIf="cardType=='mostRaised' && donors?.total > 1" [position]="10" class="flex-container-row mt-15" label="Spread the word"></app-fb-share>
      </div>
      <div *ngIf="cardType!=='supporters' && donors?.total > 1" class="tl-show-more">
        <button class="tl-show-more-btn" mat-button (click)="toggleShowMore()">
          {{isShowMore ?  'Show less': 'Show more'}}
          <mat-icon class="tl-show-btn-icon" matSuffix>{{isShowMore ? 'keyboard_arrow_up':'keyboard_arrow_down'}}</mat-icon>
        </button>
      </div>
    </div>
    <div *ngIf="cardType=='supporters' && !donors?.error" class="tl-pagination">
      <button type="button" [disabled]="page<=1" (click)="setPagination('back')" mat-icon-button><mat-icon>keyboard_arrow_left</mat-icon></button>
      <div class="tl-pagination-label">
        <em>{{donors?.from}} - {{donors?.to}}</em> of <span>{{fundraiser?.raised?.backers}} contributions</span>
      </div>
      <button type="button" [disabled]="page==donors?.last_page" (click)="setPagination('next')" mat-icon-button><mat-icon>keyboard_arrow_right</mat-icon></button>
    </div>
  </mat-card-content>
</app-fr-card>
